module.exports = __webpack_public_path__ + "static/media/maria.c764378d.jpg";